// extracted by mini-css-extract-plugin
export var bbcyan = "PagePanel-module--bbcyan--t3QJv";
export var bbred = "PagePanel-module--bbred--GvxH7";
export var buttonPanel = "PagePanel-module--buttonPanel--YPsIa";
export var cta = "PagePanel-module--cta--V+M96";
export var ctaIcon = "PagePanel-module--ctaIcon--JX3yr";
export var description = "PagePanel-module--description--KStgr";
export var orange = "PagePanel-module--orange--dEJ5N";
export var purple = "PagePanel-module--purple--V0Cn1";
export var root = "PagePanel-module--root--4qfxv";